import React from 'react';

/**
 * Process — 5-phase engagement timeline. Auto-numbered when inside `.numbered-sections`.
 */
export default function Process() {
  const phases = [
    {
      n: '01',
      title: 'Übernahme.',
      time: 'Woche 1',
      result: 'Ihr Telefon klingelt nicht mehr.',
      lead: 'Wir übernehmen alles:',
      body:
        'Ab Tag eins sind wir der zentrale Ansprechpartner. Verantwortung wechselt — nicht in einer Übergangsphase, sondern sofort.',
    },
    {
      n: '02',
      title: 'Ist-Analyse.',
      time: 'Woche 2 – 4',
      result: 'Sie sehen zum ersten Mal, was Ihr Objekt wirklich kann.',
      lead: 'Wir schauen genau hin:',
      body:
        'Datenbasierte Analyse jedes Mietverhältnisses, jeder Abrechnung, jeder Position. Wir finden, was bisher niemand gesucht hat.',
    },
    {
      n: '03',
      title: 'Realisierung.',
      time: 'Monat 2 – 3',
      result: 'Höherer Mietertrag sofort, signifikante Vermögenssteigerung langfristig.',
      lead: 'Wir holen raus, was drin ist:',
      body:
        'Mieten auf Marktniveau. Rückstände eingetrieben. Leerstände beseitigt. Modernisierungspotenziale gehoben. Jeder Hebel wird geprüft, bewertet und — falls wirtschaftlich — gezogen.',
    },
    {
      n: '04',
      title: 'Laufender Betrieb.',
      time: 'fortlaufend',
      result: 'Sie wissen jederzeit, wo Ihr Objekt steht, ohne selbst hinschauen zu müssen.',
      lead: 'Wir halten den Betrieb sauber:',
      body:
        'Im Hintergrund laufen unsere selbst entwickelten Systeme. Das heißt für Sie: automatisierter Bankabgleich, lückenloses Mahnwesen, präzise Buchhaltung, monatlicher Bericht. Keine offenen Posten, keine vergessenen Mahnungen, keine Überraschungen.',
    },
    {
      n: '05',
      title: 'Abrechnung & Strategie.',
      time: 'fortlaufend',
      result: 'Optimierung als Kreislauf. Ihr Objekt wird jedes Jahr besser, nicht schlechter.',
      lead: 'Wir rechnen ab und machen es nächstes Jahr besser:',
      body:
        'Jährliche Abrechnung und Objektanalyse. Wir zeigen Ihnen, was wir erreicht haben – und was als Nächstes kommt.',
    },
  ];

  return (
    <section style={{ padding: '140px 0' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Unser 5-Schritte-Erfolgsprozess</span>
        </div>
        <h2 className="h-section reveal" style={{ marginBottom: 46, maxWidth: '22ch' }}>
          So läuft eine Zusammenarbeit mit uns.
        </h2>

        <div style={{ position: 'relative', paddingLeft: 32 }}>
          <div
            aria-hidden="true"
            style={{
              position: 'absolute',
              left: 4,
              top: 12,
              bottom: 12,
              width: 1,
              background: 'var(--cream-line)',
            }}
          />

          {phases.map((p, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                position: 'relative',
                paddingBottom: i < phases.length - 1 ? 48 : 0,
              }}
            >
              <div
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  left: -32,
                  top: 12,
                  width: 9,
                  height: 9,
                  background: 'var(--bordeaux)',
                  borderRadius: 0,
                }}
              />
              <div
                style={{
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                  fontSize: 11,
                  letterSpacing: '0.16em',
                  color: 'var(--charcoal-muted)',
                  marginBottom: 8,
                }}
              >
                {p.n} · {p.time}
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '240px 1fr',
                  gap: 50,
                  alignItems: 'baseline',
                }}
              >
                <div>
                  <h3 className="h-pillar" style={{ fontSize: 24 }}>
                    {p.title}
                  </h3>
                  {p.result && (
                    <div
                      style={{
                        marginTop: 12,
                        paddingTop: 12,
                        borderTop: '1px solid var(--cream-line)',
                        fontFamily: 'var(--serif)',
                        fontStyle: 'italic',
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: 'var(--bordeaux)',
                      }}
                    >
                      {p.result}
                    </div>
                  )}
                </div>
                <p
                  className="body-prose"
                  style={{
                    fontSize: 17,
                    color: 'var(--charcoal-muted)',
                    maxWidth: '70ch',
                  }}
                >
                  {p.lead && (
                    <strong style={{ color: 'var(--anthracite)', fontWeight: 600 }}>
                      {p.lead}
                    </strong>
                  )}
                  {p.lead && ' '}
                  {p.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
